export const fonts = {
  RALEWAY: "Raleway, Arial, Helvetica, sans-serif, sans-serif",
  OSWALD: 'Oswald, "Franklin Gothic Medium", "Arial Narrow"',
}
